<template lang="pug">
div
    div.row
        div.col-sm-12.col-xl-12
            subsidy-datatable(ref="datatable")
</template>

<script>
import SubsidyDatatable from './datatable.vue';

export default {
    components: {
        SubsidyDatatable,
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/subsidy/index.vue